import { render, staticRenderFns } from "./PurchaseExtension.vue?vue&type=template&id=67f2eca4&"
import script from "./PurchaseExtension.vue?vue&type=script&lang=js&"
export * from "./PurchaseExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports